var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M279.1 288l14.3-92.7h-89v-60c0-25.4 12.5-50.2 52.3-50.2H297V6.4S260.4 0 225.4 0C152 0 104.3 44.4 104.3 124.7v70.6H22.9V288h81.4v224h100.2V288z"}));
}

FacebookInline.defaultProps = {"aria-hidden":"true","viewBox":"0 0 320 512"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
